import reframe, { dispatch, dispatchSync } from 'nike-re-framejs';
import * as services from './services';
import { nikeOneMiddlewares } from '@/common/util';
import { mergeUpdater, setUpdater } from './domain/DBDetail';
import { useEffect } from 'react';
import Immutable, { fromJS } from 'immutable';
import { createOrderedIndex, indexById } from 'nike-ui/src/components/turboLive/push/indexingUtils';
import {
    indexOrderedBetsByMarket,
    matchDetailMbmSnapshot
} from 'nike-ui/src/components/turboLive/push/detail/handlers';
import { getCombinablePrematchBets } from 'nike-ui/src/components/combinable-bets/betExclusionValidations';
import { isProfileCombinableBetsEnabled } from 'nike-ui/src/profiles';

const doInN1 = f => db => db.updateIn(['nikeone'], Immutable.Map(), f);
const doInTLDetail = f => db => db.updateIn(['turboLive', 'detail'], Immutable.Map(), f);

reframe.registerHandler(
    'nikeone.clearDetail',
    nikeOneMiddlewares,
    // TODO cistit ci necistit, to je otazka
    db => db
);

export const loadEventDetail = (sportEventId, isPromoPage = false) => db => {
    return [
        doInN1(n1 => n1.setIn(['detail', '_loading'], sportEventId))(db),
        doLoadEventDetail(sportEventId, isPromoPage)
    ];
};

export const useNikeoneEventLoad = (sportEventId, isPromoPage) => {
    useEffect(() => {
        dispatch(loadEventDetail(sportEventId, isPromoPage));
        return () => {
            dispatch(['nikeone.clearDetail']);
            dispatch(deleteTLVDetail);
        };
        // eslint-disable-next-line
    }, [sportEventId]);
};

function getAllowMarketCombinations(bets) {
    return bets[0]?.combinationRules.tournamentAllowMarketCombinations || false;
}

function getMatchId(bets) {
    return bets[0]?.sportEventId || false;
}

const eventDetailLoaded = (loadingId, json) => db => [
    doInN1(n1 => {
        if (n1.getIn(['detail', '_loading']) !== loadingId) {
            return n1;
        }
        let useMerge = false;
        if (n1.getIn(['detail', '_loaded']) === loadingId) {
            useMerge = true;
        }
        const detailData = fromJS(json);
        const sportEventId = detailData
            .get('sportEvents')
            ?.first()
            ?.get('sportEventId');
        const marketId = detailData
            ?.get('boxes')
            ?.first()
            ?.getIn(['selectedBetsHierarchy', sportEventId])
            ?.first()
            ?.first()
            ?.get('betHeaders')
            ?.first()
            ?.get('sportEvents')
            ?.first()
            ?.get('marketId');
        const result = detailData
            ?.get('bets')
            ?.find(bet => bet.get('marketId') === marketId)
            ?.get('result');

        let newN1 = n1
            .setIn(['detail', '_loaded'], loadingId)
            .deleteIn(['detail', '_loading'])
            .updateIn(['detail', 'data'], useMerge ? mergeUpdater(json) : setUpdater(json));

        if (result?.get('awayScore') && result?.get('homeScore')) {
            newN1 = newN1.setIn(['detail', 'data', 'sportEvent', 'result'], result);
        }

        return newN1;
    })(db),
    doInTLDetail(tlDetail => {
        const matchId = getMatchId(json.bets);
        const combinableBets = isProfileCombinableBetsEnabled() ? getCombinablePrematchBets(json.bets, matchId) : null;

        return tlDetail
            .setIn(['markets'], indexById(json.markets, 'marketId'))
            .setIn(['bets'], indexById(json.bets, 'betId'))
            .setIn(['marketCategories'], indexById(json.marketCategories))
            .setIn(['marketIdsByOrder'], createOrderedIndex(json.markets, 'order', 'marketId'))
            .setIn(['marketCategoryIdsByOrder'], createOrderedIndex(json.marketCategories))
            .setIn(['betIdsByMarket'], indexOrderedBetsByMarket(json.bets, 'betOrder', 'betId'))
            .setIn(['tournamentAllowMarketCombinations'], getAllowMarketCombinations(json.bets))
            .setIn(
                ['combinableBetIdsByMarket'],
                combinableBets ? indexOrderedBetsByMarket(combinableBets, 'betOrder', 'betId') : Immutable.Map()
            )
            .setIn(['matchId'], matchId)
            .setIn(['isPrematch'], true);
    })
];

export const clearStatistics = doInN1(n1 => n1.removeIn(['detail', 'statistics']));

const doLoadEventDetail = (sportEventId, isPromoPage) => () => {
    // if (sportEventId) {
    //     services
    //         .loadDetailByBetId(sportEventId)
    //         .then(data => reframe.dispatch(eventDetailLoaded(loadingId, data)))
    //         .catch(error => {
    //             if (error?.response?.status === 404) {
    //                 doLoadEventDetail(sportEventId, loadingId)();
    //             }
    //         });
    // } else {
    services.loadDetailBySportEventId(sportEventId).then(data => {
        if (isPromoPage) {
            dispatchSync(eventDetailLoaded(sportEventId, data));
            dispatchSync(matchDetailMbmSnapshot(data.mbm));
        } else {
            dispatch(eventDetailLoaded(sportEventId, data));
            dispatch(matchDetailMbmSnapshot(data.mbm));
        }
    });
    //}
};

export const deleteTLVDetail = () => db => db.deleteIn(['turboLive', 'detail']);
